import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './AssessmentPage.css';
import './NotFound.css';

/**
 * Page not found.
 * Shown for any address the site doesn't know. Azure serves the pre-rendered
 * /404 copy of this page with a real 404 status (see staticwebapp.config.json).
 */
const NotFound = () => {
  return (
    <div className="page-assessment" data-testid="not-found-page">
      <SEO
        title="Page not found | Clinical Minds Psychology"
        description="This page couldn't be found. Head back to the Clinical Minds Psychology homepage, our assessments or the contact page."
        canonicalUrl="https://www.clinicalminds.net/404"
        noindex={true}
      />

      <section id="main-content" className="interior-hero">
        <div className="container">
          <span className="section-label">Page not found</span>
          <h1 className="heading-hero">We couldn't find that page</h1>
        </div>
      </section>

      <section className="assess-section">
        <div className="container assess-narrow">
          <div className="assess-body">
            <p>The page may have moved, or the link may have a small typo. These will get you back on track:</p>
          </div>
          <div className="not-found-links" data-testid="not-found-links">
            <Link to="/" className="btn-primary">Home</Link>
            <Link to="/services" className="btn-secondary">Assessments</Link>
            <Link to="/contact" className="btn-secondary">Contact</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
